import { type Epic, combineEpics } from 'redux-observable';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs';
import { request } from '@/core';
import { fetchEventsRequest } from '@/api/events';
import {
  tryFetchEvents,
  fetchEvents,
  setEvents,
  setPagination,
} from '../actions';
import { eventsByPropertyIdAndPage } from '../selectors';

const tryFetchEventsEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(tryFetchEvents.match),
    withLatestFrom(state$),
    map(([{ payload }, state]) => {
      const {
        propertyId,
        pagination: { page = 1 },
        filters,
      } = payload;

      const events = eventsByPropertyIdAndPage(state, {
        propertyId,
        page,
      });

      if (
        !events ||
        (filters?.typeIds && filters.typeIds.length >= 0) ||
        (filters?.statusIds && filters.statusIds.length >= 0) ||
        (filters?.search && filters.search.length >= 0)
      ) {
        return fetchEvents(payload);
      }

      return {
        type: 'EVENTS_ALREADY_FETCHED',
      };
    }),
  );

const fetchEventsEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchEvents.match),
    request(({ payload }) => fetchEventsRequest(payload), fetchEvents),
  );

const fetchEventsSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchEvents.succeeded.match),
    mergeMap(
      ({
        payload: {
          data: { data: events, ...pagination },
          originalData: { propertyId },
        },
      }) => [
        setEvents({
          propertyId,
          page: pagination?.page,
          events,
        }),
        setPagination({ propertyId, pagination }),
      ],
    ),
  );

export default combineEpics(
  tryFetchEventsEpic,
  fetchEventsEpic,
  fetchEventsSucceededEpic,
);
